import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/store";

axios.interceptors.request.use((config) => {
  try {
    const state = store.getState();
    const user = state?.auth?.data?.user;
    if (user) {
      const actorName =
        user.managerName ||
        user.adminName ||
        user.docName ||
        user.agentName ||
        user.name ||
        user.email;
      const actorId =
        user.managerID ||
        user.adminID ||
        user.docID ||
        user.agentID ||
        user._id;
      const actorType = user.userType;

      if (actorName && !config.headers["x-actor-name"]) {
        config.headers["x-actor-name"] = actorName;
      }
      if (actorId && !config.headers["x-actor-id"]) {
        config.headers["x-actor-id"] = actorId.toString();
      }
      if (actorType && !config.headers["x-actor-type"]) {
        config.headers["x-actor-type"] = actorType;
      }
    }
  } catch (_err) {
    // ignore
  }
  return config;
}, (error) => Promise.reject(error));

const root = ReactDOM.createRoot(document.getElementById("root"));

const Router = process.env.REACT_APP_BUILD_ROUTER === 'HASH' ? HashRouter : BrowserRouter;

root.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
);
